import { channelLogData } from '~/stores/data/ChannelLogData';

class Data {
  channelLogData = channelLogData;
}

export default Data;

export const data = new Data();
